<div class="list-container">
  <h1 class="text-2xl font-bold mb-4">
    Consulta Master Data - CL
  </h1>

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  @if (success) {
    <app-alert [type]="'success'">{{ success }}</app-alert>
  }

  <div class="bg-white dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-700 rounded-md p-4 mb-6">
    <label class="block text-sm font-medium mb-2">
      E-mail do cliente
    </label>

    <div class="flex flex-col md:flex-row gap-3">
      <input
        type="email"
        [(ngModel)]="email"
        placeholder="Digite o e-mail do cliente"
        class="w-full border border-neutral-300 dark:border-neutral-600 rounded-md px-3 py-2 bg-white dark:bg-neutral-800"
        [disabled]="loading || saving"
        (keyup.enter)="searchByEmail()"
      />

      <button
        type="button"
        class="btn rounded-md flex items-center justify-center gap-2 bg-black text-white hover:bg-neutral-800 py-2 px-4 text-sm disabled:opacity-60"
        [disabled]="loading || saving"
        (click)="searchByEmail()"
      >
        @if (loading) {
          Buscando...
        } @else {
          Buscar
        }
      </button>
    </div>
  </div>

  @if (loading) {
    <div class="mb-4">
      <app-loading size="large" color="primary"/>
    </div>
  }

  @if (!loading && client) {
    <div class="bg-white dark:bg-neutral-900 border border-neutral-300 dark:border-neutral-700 rounded-md p-4 mb-6">
      <h2 class="text-xl font-semibold mb-4">
        Editar campo do cliente
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-sm font-medium mb-2">
            Documento Master Data
          </label>

          <input
            type="text"
            [value]="getDocumentId()"
            disabled
            class="w-full border border-neutral-300 dark:border-neutral-600 rounded-md px-3 py-2 bg-neutral-100 dark:bg-neutral-800"
          />
        </div>

        <div>
          <label class="block text-sm font-medium mb-2">
            E-mail
          </label>

          <input
            type="text"
            [value]="client.email"
            disabled
            class="w-full border border-neutral-300 dark:border-neutral-600 rounded-md px-3 py-2 bg-neutral-100 dark:bg-neutral-800"
          />
        </div>
      </div>

      <div class="border border-neutral-300 dark:border-neutral-700 rounded-md p-4 mb-4">
        <label class="block text-sm font-medium mb-2">
          Documento
        </label>
          <input
            type="text"
            [(ngModel)]="editableFieldValue"
            placeholder="Digite o documento"
            class="w-full border border-neutral-300 dark:border-neutral-600 rounded-md px-3 py-2 bg-white dark:bg-neutral-800"
            [disabled]="saving"
          />

      </div>

      <div class="flex justify-end">
        <button
          type="button"
          class="btn rounded-md flex items-center justify-center gap-2 bg-black text-white hover:bg-neutral-800 py-2 px-4 text-sm disabled:opacity-60"
          [disabled]="saving || !hasChanges()"
          (click)="saveEditableField()"
        >
          @if (saving) {
            Salvando...
          } @else {
            Salvar alteração
          }
        </button>
      </div>
    </div>

    <div class="overflow-x-auto">
      <h2 class="text-xl font-semibold mb-4">
        Dados retornados da CL
      </h2>

      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead>
          <tr class="bg-neutral-100 dark:bg-neutral-700">
            <th class="border border-neutral-300 dark:border-neutral-600 p-2 text-left">
              Campo
            </th>
            <th class="border border-neutral-300 dark:border-neutral-600 p-2 text-left">
              Valor
            </th>
          </tr>
        </thead>

        <tbody>
          @for (field of getClientFields(); track field.key; let even = $even) {
            <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
              <td class="border border-neutral-300 dark:border-neutral-600 p-2 font-medium">
                {{ field.key }}
              </td>

              <td class="border border-neutral-300 dark:border-neutral-600 p-2 break-all">
                {{ formatValue(field.value) }}
              </td>
            </tr>
          } @empty {
            <tr>
              <td
                colspan="2"
                class="border border-neutral-300 dark:border-neutral-600 p-2 text-center"
              >
                Nenhum dado encontrado.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>